import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Questionnaire from '../../../../libs/api/services/Questionnaire'
import { QuestionnaireBuilderProvider } from '../builder/QuestionnaireBuilderProvider'
import QCaptureComponentNew from './components/QCaptureComponentNew'
import QuestionnaireCanvas from '../v2/questionnaireCanvas'

export default function QCapture() {
    const { questionnaireId, QuestionnaireAssignmentId } = useParams()
    const [details, setDetails] = useState()
    // const loadDetails = async () => {

    //     const res = await Questionnaire
    //         .GetQuestionnaireResultsFull(QuestionnaireAssignmentId)
    //     setDetails(res)
    // }

    // useEffect(() => {
    //     loadDetails()
    // }, [])

    // return (
    //     details
    //         ?
    //         <QuestionnaireBuilderProvider assignmentId={QuestionnaireAssignmentId}>
    //             <div className='m-2 position-relative h-100'>
    //                 {details && details.questionnaire && details.questionnaire.resource && <QCaptureComponentNew
    //                     cachedDetails={details}
    //                     QuestionnaireAssignmentId={QuestionnaireAssignmentId}
    //                     QuestionnaireId={questionnaireId} />}
    //                 {/* <QCaptureComponent
    //                 cacheddetails={details}
    //                 QuestionnaireAssignmentId={QuestionnaireAssignmentId}
    //                 QuestionnaireId={questionnaireId} /> */}
    //             </div>
    //         </QuestionnaireBuilderProvider>
    //         :
    //         <div className='d-flex align-items-center justify-content-center flex-grow-1'><FontAwesomeIcon spin icon={faSpinner} /></div>
    // )
    return <QuestionnaireCanvas assignmentId={QuestionnaireAssignmentId} questionnaireId={questionnaireId} />
}
// 718389BF-E1D4-47A8-B660-1B8287E40611